import { axiosInstance } from "../Middleware";
import { ChangeStatusValidationReponse, ChangeStatusValidationReponseResultat } from "./type";

export class ValidationReponseApi {
    public static async updateValidationReponse(data: ChangeStatusValidationReponse) {
        const response = await axiosInstance.put<ChangeStatusValidationReponseResultat>("/personnel/personnel/validationsreponses/change-status", data)
        return response
    }
}
